module.exports = __webpack_public_path__ + "img/NoDocuments.fc851e77.png";